// import { ThunkDispatch, UnknownAction } from '@reduxjs/toolkit';

import { InboundNSIntegrationStatusEnum } from 'commons/enums';
import { IInboundInvoice } from 'commons/types';

export const RowMenuItemConfig = [
  {
    name: 'Retry',
    disabled: (selected: IInboundInvoice[]): boolean => {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < selected.length; i++) {
        if (
          selected[i].integration_status ===
          InboundNSIntegrationStatusEnum.NS_FAILED
        )
          return false;
      }
      return true;
    },
  },
];
